/**
 * Help - Buro42 Helpcentrum
 * Uitgebreide gebruikershandleiding in stijl van Boekhouding Help
 */

import { Link } from 'react-router-dom';
import './Help.css';

const Help = () => {
  return (
    <div className="help-page">
      {/* Vaste header met navigatie */}
      <div className="help-header-fixed">
        <h1>Buro42 Helpcentrum</h1>
        <p className="help-subtitle">Vind antwoorden op veelgestelde vragen en leer hoe u Buro42 optimaal benut.</p>

        {/* Snelkoppelingen met iconen */}
        <div className="help-quick-buttons">
        <a href="#dashboard" className="help-quick-btn">
          <span className="help-quick-icon">🏠</span>
          <span>Dashboard</span>
        </a>
        <a href="#relaties" className="help-quick-btn">
          <span className="help-quick-icon">👥</span>
          <span>Relaties</span>
        </a>
        <a href="#klantportaal" className="help-quick-btn">
          <span className="help-quick-icon">🌐</span>
          <span>Klantportaal</span>
        </a>
        <a href="#personeel" className="help-quick-btn">
          <span className="help-quick-icon">👷</span>
          <span>Personeel</span>
        </a>
        <a href="#boten" className="help-quick-btn">
          <span className="help-quick-icon">⛵</span>
          <span>Boten</span>
        </a>
        <a href="#producten" className="help-quick-btn">
          <span className="help-quick-icon">📦</span>
          <span>Producten</span>
        </a>
        <a href="#offertes" className="help-quick-btn">
          <span className="help-quick-icon">📋</span>
          <span>Offertes</span>
        </a>
        <a href="#werkorders" className="help-quick-btn">
          <span className="help-quick-icon">🔧</span>
          <span>Werkorders</span>
        </a>
        <a href="#facturen" className="help-quick-btn">
          <span className="help-quick-icon">💰</span>
          <span>Facturen</span>
        </a>
        <a href="#boekhouding" className="help-quick-btn">
          <span className="help-quick-icon">📊</span>
          <span>Boekhouding</span>
        </a>
        <a href="#zoeken" className="help-quick-btn">
          <span className="help-quick-icon">🔍</span>
          <span>Zoeken</span>
        </a>
        <a href="#instellingen" className="help-quick-btn">
          <span className="help-quick-icon">⚙️</span>
          <span>Instellingen</span>
        </a>
        </div>
      </div>

      {/* Content sectie die scrollt */}
      <div className="help-content">

      {/* Dashboard */}
      <div className="help-section">
        <h2 id="dashboard">Dashboard</h2>
        <p>Het dashboard is je startpunt in Buro42. Hier zie je in één oogopslag wat er speelt.</p>

        <h3>Overzicht</h3>
        <p>Op het dashboard vind je:</p>
        <ul>
          <li><strong>Welkomstbericht</strong> - Met je ingelogde gebruikersnaam</li>
          <li><strong>Snelkoppelingen</strong> - Directe toegang tot veelgebruikte functies</li>
          <li><strong>Scan</strong> - Snel producten scannen met je camera</li>
          <li><strong>Scan Inkoop</strong> - Inkoopfacturen scannen met AI</li>
        </ul>

        <h3>Snelkoppelingen</h3>
        <table>
          <tbody>
            <tr><th>Knop</th><th>Wat het doet</th></tr>
            <tr><td><strong>Relaties</strong></td><td>Beheer klanten en leveranciers</td></tr>
            <tr><td><strong>Boten</strong></td><td>Beheer boten en boot modellen</td></tr>
            <tr><td><strong>Producten</strong></td><td>Beheer producten en materialen</td></tr>
            <tr><td><strong>Urenregistratie</strong></td><td>Registreer gewerkte uren</td></tr>
            <tr><td><strong>Scan</strong></td><td>Scan voorraad producten</td></tr>
            <tr><td><strong>Scan Inkoop</strong></td><td>Scan inkoopfacturen met AI</td></tr>
            <tr><td><strong>Boekhouding</strong></td><td>Financiële administratie</td></tr>
          </tbody>
        </table>
      </div>

      {/* Relaties */}
      <div className="help-section">
        <h2 id="relaties">Relaties</h2>
        <p>Beheer al je klanten, leveranciers en ZZP'ers op één plek.</p>

        <h3>Navigatie</h3>
        <table>
          <tbody>
            <tr><th>Menu</th><th>Wat het doet</th></tr>
            <tr><td><strong>Klanten</strong></td><td>Overzicht van alle klanten</td></tr>
            <tr><td><strong>Leveranciers</strong></td><td>Overzicht van alle leveranciers</td></tr>
            <tr><td><strong>ZZP'ers</strong></td><td>Externe medewerkers voor werkorders</td></tr>
          </tbody>
        </table>

        <h3>Nieuwe relatie toevoegen</h3>
        <ol>
          <li>Ga naar <strong>Relaties</strong> en kies het type (Klanten/Leveranciers/ZZP'ers)</li>
          <li>Klik op <strong>+ Nieuwe Klant</strong> (of Leverancier/ZZP'er)</li>
          <li>Vul de gegevens in:
            <ul>
              <li><strong>Naam</strong> - Bedrijfsnaam of persoonsnaam</li>
              <li><strong>Email</strong> - Voor offertes en facturen</li>
              <li><strong>Telefoon</strong> - Contactnummer</li>
              <li><strong>Adres</strong> - Straat, postcode, plaats</li>
              <li><strong>BTW-nummer</strong> - Voor zakelijke klanten</li>
              <li><strong>Notities</strong> - Interne opmerkingen</li>
            </ul>
          </li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>

        <h3>Klantpagina bekijken</h3>
        <p>Klik op een klant in de lijst om de detailpagina te openen. Hier zie je:</p>
        <ul>
          <li><strong>Contactgegevens</strong> - Alle klantinformatie</li>
          <li><strong>Boten</strong> - Gekoppelde boten van deze klant</li>
          <li><strong>Offertes</strong> - Alle offertes voor deze klant</li>
          <li><strong>Werkorders</strong> - Lopende en afgeronde werkorders</li>
          <li><strong>Facturen</strong> - Factuurhistorie</li>
          <li><strong>Klantenportaal</strong> - Link om te delen met de klant</li>
        </ul>

        <h3>Relatie bewerken of verwijderen</h3>
        <ul>
          <li><strong>Bewerken</strong> - Klik op de klant en dan op "Bewerken"</li>
          <li><strong>Verwijderen</strong> - Alleen mogelijk als er geen gekoppelde boten/offertes zijn</li>
        </ul>
      </div>

      {/* Klantportaal */}
      <div className="help-section">
        <h2 id="klantportaal">Klantenportaal</h2>
        <p>Geef klanten toegang tot hun eigen portaal waar ze hun boot en offertes kunnen bekijken.</p>

        <h3>Portaal activeren</h3>
        <ol>
          <li>Ga naar de <strong>klantpagina</strong></li>
          <li>Scroll naar de sectie <strong>Klantenportaal</strong></li>
          <li>Klik op <strong>Genereer Portaal Link</strong></li>
          <li>Kopieer de link en deel deze met de klant (email/WhatsApp)</li>
        </ol>

        <h3>Portaal beheren</h3>
        <table>
          <tbody>
            <tr><th>Actie</th><th>Wat het doet</th></tr>
            <tr><td><strong>Kopieer Link</strong></td><td>Kopieer de portaal URL naar klembord</td></tr>
            <tr><td><strong>Open Portaal</strong></td><td>Bekijk het portaal zoals de klant het ziet</td></tr>
            <tr><td><strong>Vernieuw Link</strong></td><td>Maak een nieuwe link (oude vervalt)</td></tr>
            <tr><td><strong>Trek Link In</strong></td><td>Blokkeer de toegang volledig</td></tr>
          </tbody>
        </table>

        <h3>Wat ziet de klant?</h3>
        <p>In het portaal kan de klant het volgende bekijken:</p>
        <ul>
          <li><strong>Boot specificaties</strong> - Model, afmetingen, bouwjaar</li>
          <li><strong>Gemonteerde onderdelen</strong> - Motor, generator, pompen en filters, met positie, serienummer, draaiuren en vervangingsdata</li>
          <li><strong>Onderhoudsschema</strong> - Wanneer onderhoud nodig is</li>
          <li><strong>Handleidingen</strong> - PDF's bij elk onderdeel</li>
          <li><strong>Offertes</strong> - Openstaande offertes accorderen</li>
        </ul>

        <h3>Statistieken</h3>
        <p>Op de klantpagina zie je hoeveel keer de klant het portaal heeft bezocht en wanneer de laatste toegang was.</p>
      </div>

      {/* Personeel */}
      <div className="help-section">
        <h2 id="personeel">Personeel</h2>
        <p>Beheer je medewerkers, hun rechten en urenregistratie.</p>

        <h3>Navigatie</h3>
        <table>
          <tbody>
            <tr><th>Menu</th><th>Wat het doet</th></tr>
            <tr><td><strong>Werknemers</strong></td><td>Overzicht van alle medewerkers</td></tr>
            <tr><td><strong>Urenregistratie</strong></td><td>Uren registreren op werkorders</td></tr>
          </tbody>
        </table>

        <h3>Werknemer toevoegen</h3>
        <ol>
          <li>Ga naar <strong>Personeel → Werknemers</strong></li>
          <li>Klik op <strong>+ Nieuwe Werknemer</strong></li>
          <li>Vul de gegevens in:
            <ul>
              <li><strong>Naam</strong> - Volledige naam</li>
              <li><strong>Email</strong> - Voor inloggen en notificaties</li>
              <li><strong>Telefoon</strong> - Contactnummer</li>
              <li><strong>Functie</strong> - Bijv. Monteur, Administratie</li>
              <li><strong>Uurtarief</strong> - Voor facturatie</li>
              <li><strong>Splash Screen</strong> - Vink uit om opstartscherm over te slaan</li>
            </ul>
          </li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>

        <h3>Persoonlijke instellingen</h3>
        <p>Elke werknemer kan zijn eigen voorkeuren instellen:</p>
        <ul>
          <li><strong>Splash Screen Toggle</strong> - Zet het opstartscherm aan of uit per gebruiker</li>
          <li><strong>Rol aanpassen</strong> - Wijzig permissies en toegangsrechten</li>
          <li><strong>Contact gegevens</strong> - Bijwerken van telefoon en email</li>
        </ul>

        <h3>Rollen & Permissies</h3>
        <p>Buro42 heeft 6 vaste rollen met standaard permissies. Deze permissies kun je per rol aanpassen.</p>

        <h3>Beschikbare rollen</h3>
        <table>
          <tbody>
            <tr><th>Rol</th><th>Standaard rechten</th></tr>
            <tr><td><strong>Admin</strong></td><td>Volledige toegang (niet aanpasbaar)</td></tr>
            <tr><td><strong>Accountant</strong></td><td>Rapportages + uren na weekafsluiting</td></tr>
            <tr><td><strong>Teamleider</strong></td><td>Uren/materiaal voor team op alle werkorders</td></tr>
            <tr><td><strong>Chef</strong></td><td>Uren/materiaal voor team op toegewezen werkorders</td></tr>
            <tr><td><strong>Werknemer</strong></td><td>Eigen uren + magazijn op/afboeken op project</td></tr>
            <tr><td><strong>Klant</strong></td><td>Alleen lezen in klantportaal</td></tr>
          </tbody>
        </table>

        <h3>Permissies aanpassen</h3>
        <ol>
          <li>Ga naar <strong>Instellingen → Rollen & Permissies</strong></li>
          <li>Klik op een <strong>rol tab</strong> (bijv. Werknemer)</li>
          <li>Vink permissies aan of uit per categorie:
            <ul>
              <li><strong>Uren</strong> - Eigen/team uren registreren</li>
              <li><strong>Magazijn</strong> - Voorraad bekijken/boeken</li>
              <li><strong>Werkorders</strong> - Aanmaken/wijzigen/verwijderen</li>
              <li><strong>Offertes</strong> - Bekijken/aanmaken/goedkeuren</li>
              <li><strong>Relaties</strong> - Klanten/leveranciers beheren</li>
              <li><strong>Rapportages</strong> - Overzichten/exports</li>
            </ul>
          </li>
          <li>Klik op <strong>Wijzigingen Opslaan</strong></li>
        </ol>
        <p><em>Tip: Klik op een categorie checkbox om alle permissies in die categorie tegelijk aan/uit te zetten.</em></p>
        <p><em>Reset naar Standaard zet de permissies terug naar de oorspronkelijke waarden.</em></p>

        <h3>Urenregistratie</h3>
        <ol>
          <li>Ga naar <strong>Personeel → Urenregistratie</strong></li>
          <li>Selecteer de <strong>datum</strong></li>
          <li>Selecteer de <strong>werkorder</strong></li>
          <li>Vul in: Aantal uren, Omschrijving van werkzaamheden</li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>
        <p>Geregistreerde uren worden automatisch meegenomen bij het factureren van werkorders.</p>
      </div>

      {/* Boten */}
      <div className="help-section">
        <h2 id="boten">Boten</h2>
        <p>Registreer bootmodellen en klantboten met alle technische details.</p>

        <h3>Navigatie</h3>
        <table>
          <tbody>
            <tr><th>Menu</th><th>Wat het doet</th></tr>
            <tr><td><strong>Boot Modellen</strong></td><td>Standaard modellen definiëren</td></tr>
            <tr><td><strong>Klant Boten</strong></td><td>Individuele boten van klanten</td></tr>
          </tbody>
        </table>

        <h3>Boot model aanmaken</h3>
        <ol>
          <li>Ga naar <strong>Boten → Boot Modellen</strong></li>
          <li>Klik op <strong>+ Nieuw Model</strong></li>
          <li>Vul in: Fabrikant, Modelnaam, Type, Afmetingen</li>
          <li>Voeg standaard onderdelen toe die bij dit model horen</li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>

        <h3>Klant boot registreren</h3>
        <ol>
          <li>Ga naar <strong>Boten → Klant Boten</strong></li>
          <li>Klik op <strong>+ Nieuwe Boot</strong></li>
          <li>Selecteer de <strong>klant</strong></li>
          <li>Kies een <strong>boot model</strong> (optioneel)</li>
          <li>Vul in:
            <ul>
              <li><strong>Bootnaam</strong> - Naam van de boot</li>
              <li><strong>Registratienummer</strong> - Officieel nummer</li>
              <li><strong>Bouwjaar</strong> - Jaar van fabricage</li>
              <li><strong>Ligplaats</strong> - Huidige locatie</li>
            </ul>
          </li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>

        <h3>Onderdelen registreren (ook de motor)</h3>
        <p>
          Een motor is een onderdeel als elk ander. Er is geen apart motorscherm meer:
          je voegt de motor, de generator, een pomp of een filter op dezelfde manier toe,
          onderaan de bootpagina bij <strong>Gemonteerde onderdelen</strong>.
        </p>
        <ol>
          <li>Open de bootpagina en scroll naar <strong>Gemonteerde onderdelen</strong></li>
          <li>Zoek het product in de catalogus</li>
          <li>Vul in wat bekend is: positie, serienummer, draaiuren, installatiedatum</li>
          <li>Klik op <strong>+ Toevoegen</strong></li>
        </ol>
        <p>
          Het <strong>serienummer</strong> hoort hier en niet in de productcatalogus: in de
          catalogus staat het type, bijvoorbeeld een Volvo Penta D1-13. Het exemplaar met
          een serienummer bestaat pas op het moment dat bekend is in welke boot het zit.
        </p>
        <p>Verder vast te leggen per onderdeel:</p>
        <ul>
          <li><strong>Levensduur</strong> - In uren of maanden</li>
          <li><strong>Garantie</strong> - Tot wanneer garantie geldt</li>
          <li><strong>Handleiding</strong> - Link naar PDF</li>
        </ul>
      </div>

      {/* Producten */}
      <div className="help-section">
        <h2 id="producten">Producten & Voorraad</h2>
        <p>Beheer je producten, materialen en voorraadniveaus.</p>

        <h3>Navigatie</h3>
        <table>
          <tbody>
            <tr><th>Menu</th><th>Wat het doet</th></tr>
            <tr><td><strong>Alle Producten</strong></td><td>Complete productcatalogus</td></tr>
            <tr><td><strong>Categorieën</strong></td><td>Filter op productcategorie</td></tr>
            <tr><td><strong>Scheepsonderdelen</strong></td><td>Technische onderdelen met documentatie</td></tr>
          </tbody>
        </table>

        <h3>Product toevoegen</h3>
        <ol>
          <li>Ga naar <strong>Producten → Alle Producten</strong></li>
          <li>Klik op <strong>+ Nieuw Product</strong></li>
          <li>Vul in:
            <ul>
              <li><strong>Artikelnummer</strong> - Unieke code</li>
              <li><strong>Naam</strong> - Productnaam</li>
              <li><strong>Categorie</strong> - Productgroep</li>
              <li><strong>Inkoopprijs</strong> - Prijs van leverancier</li>
              <li><strong>Verkoopprijs</strong> - Prijs voor klant</li>
              <li><strong>BTW</strong> - 21%, 9% of 0%</li>
              <li><strong>Voorraad</strong> - Huidige hoeveelheid</li>
              <li><strong>Minimum voorraad</strong> - Voor alerts</li>
            </ul>
          </li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>

        <h3>Voorraad bijwerken</h3>
        <ul>
          <li><strong>Handmatig</strong> - Open product en pas voorraad aan</li>
          <li><strong>Via bestelling</strong> - Voorraad wordt automatisch verhoogd bij ontvangst</li>
          <li><strong>Via werkorder</strong> - Voorraad wordt automatisch verlaagd bij gebruik</li>
        </ul>

        <h3>Voorraad alerts</h3>
        <p>Producten met voorraad onder het minimum verschijnen in de <strong>Bestelpool</strong>. Hier kun je direct een bestelling aanmaken bij de leverancier.</p>

        <h3>Product scannen</h3>
        <p>Scan snel producten met je camera:</p>
        <ol>
          <li>Ga naar het <strong>Dashboard</strong> en klik op <strong>Scan</strong></li>
          <li>Richt de camera op het etiket of de artikelnaam</li>
          <li>De tekst wordt automatisch herkend en opgezocht in de catalogus</li>
          <li>Bekijk direct de productdetails, voorraad en prijs</li>
        </ol>
        <p><em>Tip: Werkt ook op je telefoon - handig in het magazijn!</em></p>
      </div>

      {/* Offertes */}
      <div className="help-section">
        <h2 id="offertes">Offertes</h2>
        <p>Maak professionele offertes en verstuur ze naar klanten.</p>

        <h3>Nieuwe offerte maken</h3>
        <ol>
          <li>Ga naar <strong>Offertes → Nieuwe Offerte</strong></li>
          <li>Selecteer de <strong>klant</strong></li>
          <li>Selecteer optioneel een <strong>boot</strong></li>
          <li>Voeg regels toe:
            <ul>
              <li><strong>Product</strong> - Selecteer uit catalogus</li>
              <li><strong>Omschrijving</strong> - Pas tekst aan indien nodig</li>
              <li><strong>Aantal</strong> - Hoeveelheid</li>
              <li><strong>Prijs</strong> - Wordt automatisch ingevuld</li>
              <li><strong>Korting</strong> - Optioneel percentage</li>
            </ul>
          </li>
          <li>Voeg eventueel <strong>arbeidsuren</strong> toe</li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>

        <h3>Offerte status</h3>
        <table>
          <tbody>
            <tr><th>Status</th><th>Betekenis</th></tr>
            <tr><td><strong>Concept</strong></td><td>Nog in bewerking</td></tr>
            <tr><td><strong>Verzonden</strong></td><td>Naar klant gestuurd</td></tr>
            <tr><td><strong>Geaccepteerd</strong></td><td>Klant heeft akkoord gegeven</td></tr>
            <tr><td><strong>Afgewezen</strong></td><td>Klant heeft afgewezen</td></tr>
            <tr><td><strong>Verlopen</strong></td><td>Geldigheid is verstreken</td></tr>
          </tbody>
        </table>

        <h3>Offerte versturen</h3>
        <ol>
          <li>Open de offerte</li>
          <li>Klik op <strong>Verstuur per Email</strong></li>
          <li>Controleer het emailadres en bericht</li>
          <li>Klik op <strong>Verzenden</strong></li>
        </ol>
        <p>De klant ontvangt een email met PDF en kan via het klantenportaal accorderen.</p>

        <h3>Offerte naar werkorder</h3>
        <p>Na acceptatie kun je de offerte omzetten naar een werkorder via de knop <strong>Naar Werkorder</strong>. Alle regels worden automatisch overgenomen.</p>
      </div>

      {/* Werkorders */}
      <div className="help-section">
        <h2 id="werkorders">Werkorders</h2>
        <p>Plan en beheer werkzaamheden aan klantboten.</p>

        <h3>Nieuwe werkorder</h3>
        <ol>
          <li>Ga naar <strong>Werkorders → Nieuwe Werkorder</strong></li>
          <li>Selecteer <strong>klant</strong> en <strong>boot</strong></li>
          <li>Vul in:
            <ul>
              <li><strong>Omschrijving</strong> - Wat moet er gebeuren</li>
              <li><strong>Geplande datum</strong> - Wanneer uitvoeren</li>
              <li><strong>Prioriteit</strong> - Normaal/Hoog/Spoed</li>
            </ul>
          </li>
          <li>Voeg <strong>taken</strong> toe (checklijst)</li>
          <li>Voeg <strong>materialen</strong> toe uit voorraad</li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>

        <h3>Werkorder status</h3>
        <table>
          <tbody>
            <tr><th>Status</th><th>Betekenis</th></tr>
            <tr><td><strong>Concept</strong></td><td>Nog niet gepland</td></tr>
            <tr><td><strong>Gepland</strong></td><td>Ingepland voor uitvoering</td></tr>
            <tr><td><strong>In Uitvoering</strong></td><td>Er wordt aan gewerkt</td></tr>
            <tr><td><strong>Afgerond</strong></td><td>Werk is klaar</td></tr>
            <tr><td><strong>Gefactureerd</strong></td><td>Factuur is verstuurd</td></tr>
          </tbody>
        </table>

        <h3>Uren registreren</h3>
        <ol>
          <li>Ga naar <strong>Personeel → Urenregistratie</strong></li>
          <li>Selecteer de <strong>werkorder</strong></li>
          <li>Vul in: Datum, Aantal uren, Omschrijving</li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>
        <p>Geregistreerde uren worden automatisch meegenomen in de factuur.</p>

        <h3>Werkorder factureren</h3>
        <ol>
          <li>Zet de werkorder op status <strong>Afgerond</strong></li>
          <li>Klik op <strong>Factureren</strong></li>
          <li>Controleer de regels (uren + materialen)</li>
          <li>Verstuur de factuur</li>
        </ol>
      </div>

      {/* Facturen */}
      <div className="help-section">
        <h2 id="facturen">Facturen</h2>
        <p>Beheer inkoop- en verkoopfacturen.</p>

        <h3>Navigatie</h3>
        <table>
          <tbody>
            <tr><th>Menu</th><th>Wat het doet</th></tr>
            <tr><td><strong>Bestelpool</strong></td><td>Producten die besteld moeten worden</td></tr>
            <tr><td><strong>Bestellingen</strong></td><td>Inkooporders bij leveranciers</td></tr>
            <tr><td><strong>Verkoopfacturen</strong></td><td>Facturen aan klanten</td></tr>
          </tbody>
        </table>

        <h3>Bestelling plaatsen</h3>
        <ol>
          <li>Ga naar <strong>Bestelpool</strong> - hier staan producten onder minimum voorraad</li>
          <li>Selecteer producten om te bestellen</li>
          <li>Klik op <strong>Bestelling Aanmaken</strong></li>
          <li>Selecteer de <strong>leverancier</strong></li>
          <li>Pas aantallen aan indien nodig</li>
          <li>Klik op <strong>Bestelling Plaatsen</strong></li>
        </ol>

        <h3>Bestelling ontvangen</h3>
        <ol>
          <li>Ga naar <strong>Bestellingen</strong></li>
          <li>Open de bestelling</li>
          <li>Klik op <strong>Ontvangen</strong></li>
          <li>Vink aan welke producten zijn geleverd</li>
          <li>Voorraad wordt automatisch bijgewerkt</li>
        </ol>

        <h3>Verkoopfactuur maken</h3>
        <ol>
          <li>Ga naar <strong>Facturen → Nieuwe Verkoopfactuur</strong></li>
          <li>Selecteer de <strong>klant</strong></li>
          <li>Voeg regels toe met producten/diensten</li>
          <li>Stel de <strong>betalingstermijn</strong> in (standaard 14 dagen)</li>
          <li>Klik op <strong>Opslaan</strong></li>
          <li>Verstuur per email of download als PDF</li>
        </ol>

        <h3>Factuur status</h3>
        <table>
          <tbody>
            <tr><th>Status</th><th>Betekenis</th></tr>
            <tr><td><strong>Concept</strong></td><td>Nog niet verstuurd</td></tr>
            <tr><td><strong>Verzonden</strong></td><td>Naar klant gestuurd</td></tr>
            <tr><td><strong>Betaald</strong></td><td>Betaling ontvangen</td></tr>
            <tr><td><strong>Vervallen</strong></td><td>Betalingstermijn verstreken</td></tr>
          </tbody>
        </table>
      </div>

      {/* Boekhouding */}
      <div className="help-section">
        <h2 id="boekhouding">Boekhouding</h2>
        <p>Buro42 heeft een volledig geïntegreerd boekhoudingsysteem.</p>

        <h3>Boekhouding openen</h3>
        <p>Klik op <strong>Boekhouding</strong> in de navigatiebalk om naar het boekhoudingsysteem te gaan.</p>

        <h3>Belangrijkste functies</h3>
        <table>
          <tbody>
            <tr><th>Functie</th><th>Wat het doet</th></tr>
            <tr><td><strong>Boekingen</strong></td><td>Alle transacties invoeren en bekijken</td></tr>
            <tr><td><strong>Factuur Scannen</strong></td><td>AI scant automatisch inkoopfacturen</td></tr>
            <tr><td><strong>BTW Overzicht</strong></td><td>BTW aangifte per kwartaal</td></tr>
            <tr><td><strong>Debiteuren/Crediteuren</strong></td><td>Openstaande facturen</td></tr>
            <tr><td><strong>Jaarrekening</strong></td><td>Balans en exploitatie als PDF</td></tr>
          </tbody>
        </table>

        <div className="help-tip-box">
          <p><strong>Uitgebreide handleiding:</strong> Voor gedetailleerde instructies over de boekhouding, klik op de knop hieronder.</p>
          <Link to="/boekhouding/help" className="help-button">Boekhouding Handleiding</Link>
        </div>
      </div>

      {/* Instellingen */}
      <div className="help-section">
        <h2 id="instellingen">Instellingen</h2>
        <p>Configureer Buro42 naar je wensen.</p>

        <h3>Overzicht</h3>
        <table>
          <tbody>
            <tr><th>Instelling</th><th>Wat het doet</th></tr>
            <tr><td><strong>Bedrijfsgegevens</strong></td><td>Naam, adres, KvK, BTW-nummer</td></tr>
            <tr><td><strong>Email / SMTP</strong></td><td>Email server configureren</td></tr>
            <tr><td><strong>Algemene Instellingen</strong></td><td>Valuta, taal, datumformaat</td></tr>
            <tr><td><strong>Rollen & Permissies</strong></td><td>Gebruikersrechten beheren</td></tr>
            <tr><td><strong>Database Export</strong></td><td>Backup maken of data exporteren</td></tr>
          </tbody>
        </table>

        <h3>Bedrijfsgegevens instellen</h3>
        <ol>
          <li>Ga naar <strong>Instellingen → Bedrijfsgegevens</strong></li>
          <li>Vul in:
            <ul>
              <li><strong>Bedrijfsnaam</strong> - Verschijnt op documenten</li>
              <li><strong>Adres</strong> - Straat, postcode, plaats</li>
              <li><strong>KvK-nummer</strong> - Kamer van Koophandel</li>
              <li><strong>BTW-nummer</strong> - Voor facturen</li>
              <li><strong>IBAN</strong> - Bankrekening</li>
              <li><strong>Logo</strong> - Upload je bedrijfslogo</li>
            </ul>
          </li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>

        <h3>Email configureren</h3>
        <ol>
          <li>Ga naar <strong>Instellingen → Email / SMTP</strong></li>
          <li>Vul de SMTP gegevens in van je email provider</li>
          <li>Test de verbinding met <strong>Verstuur Test Email</strong></li>
          <li>Klik op <strong>Opslaan</strong></li>
        </ol>

        <h3>Database backup</h3>
        <ol>
          <li>Ga naar <strong>Instellingen → Database Export</strong></li>
          <li>Klik op <strong>Download Backup</strong></li>
          <li>Bewaar het bestand op een veilige locatie</li>
        </ol>
        <p><em>Tip: Maak regelmatig een backup, bijvoorbeeld wekelijks.</em></p>
      </div>

      {/* Zoeken & Filteren */}
      <div className="help-section">
        <h2 id="zoeken">Zoeken & Filteren</h2>
        <p>Vind snel wat je zoekt in Buro42.</p>

        <h3>Zoeken in lijsten</h3>
        <p>Bijna elke lijst heeft een zoekbalk bovenaan:</p>
        <ul>
          <li>Typ een zoekterm om direct te filteren</li>
          <li>Zoek op naam, nummer, of andere velden</li>
          <li>Resultaten worden live bijgewerkt tijdens het typen</li>
        </ul>

        <h3>Filteren</h3>
        <p>Gebruik filters om de lijst te verfijnen:</p>
        <ul>
          <li><strong>Type filter</strong> - Bijv. Klant/Leverancier bij Relaties</li>
          <li><strong>Status filter</strong> - Bijv. Open/Betaald bij Facturen</li>
          <li><strong>Datum filter</strong> - Selecteer een periode</li>
          <li><strong>Categorie filter</strong> - Bijv. productcategorieën</li>
        </ul>

        <h3>Sorteren</h3>
        <p>Klik op een kolomkop om te sorteren:</p>
        <ul>
          <li>Eerste klik: Oplopend (A-Z, laag-hoog)</li>
          <li>Tweede klik: Aflopend (Z-A, hoog-laag)</li>
          <li>Derde klik: Standaard volgorde</li>
        </ul>

        <h3>Sneltoetsen</h3>
        <table>
          <tbody>
            <tr><th>Actie</th><th>Wat het doet</th></tr>
            <tr><td><strong>Dubbelklik</strong></td><td>Open detail van item</td></tr>
            <tr><td><strong>Enter</strong></td><td>Bevestig actie / Open eerste resultaat</td></tr>
            <tr><td><strong>Escape</strong></td><td>Sluit popup / Annuleer</td></tr>
            <tr><td><strong>Tab</strong></td><td>Ga naar volgende veld</td></tr>
          </tbody>
        </table>
      </div>

      {/* Tips */}
      <div className="help-section">
        <h2 id="tips">Tips & Trucs</h2>

        <div className="help-tip-box">
          <h3>Sneltoetsen</h3>
          <ul>
            <li><strong>Zoeken</strong> - Gebruik de zoekbalk bovenaan om snel te vinden</li>
            <li><strong>Dubbelklik</strong> - Op de meeste lijsten opent dit het detail</li>
            <li><strong>Tab</strong> - Spring naar het volgende veld in formulieren</li>
          </ul>
        </div>

        <div className="help-tip-box">
          <h3>Dagelijks gebruik</h3>
          <ol>
            <li><strong>Begin bij het dashboard</strong> - Zie direct wat er speelt</li>
            <li><strong>Houd voorraad bij</strong> - Check regelmatig de bestelpool</li>
            <li><strong>Factureer tijdig</strong> - Rond werkorders snel af</li>
            <li><strong>Maak backups</strong> - Minimaal wekelijks exporteren</li>
          </ol>
        </div>

        <div className="help-tip-box">
          <h3>Mobiel gebruik</h3>
          <p>Buro42 is volledig geoptimaliseerd voor gebruik op je telefoon of tablet:</p>
          <ul>
            <li><strong>Responsieve weergave</strong> - Automatische aanpassing aan schermgrootte</li>
            <li><strong>Mobile cards</strong> - Werknemers en offertes worden getoond als kaartjes op kleine schermen</li>
            <li><strong>Touch-vriendelijk</strong> - Grote knoppen en optimale bediening met vingers</li>
            <li><strong>Hamburger menu</strong> - Tik op de 3 streepjes voor navigatie</li>
            <li><strong>Als app installeren (Android)</strong> - Chrome → Menu → Toevoegen aan startscherm</li>
            <li><strong>Als app installeren (iPhone)</strong> - Safari → Deel → Zet op beginscherm</li>
          </ul>
          
          <h4>Mobiele kaartweergave</h4>
          <p>Op telefoons worden lijsten automatisch omgezet naar overzichtelijke kaartjes:</p>
          <ul>
            <li><strong>Werknemers lijst</strong> - Naam, rol, email en telefoon in kaart vorm</li>
            <li><strong>Offertes lijst</strong> - Klant, bedrag, status met kleurcode in kaart vorm</li>
            <li><strong>Actiemogelijkheden</strong> - Alle knoppen zijn geoptimaliseerd voor aanraking</li>
          </ul>
        </div>
      </div>

      {/* Contact */}
      <div className="help-section">
        <h2>Hulp nodig?</h2>
        <p>Kom je er niet uit? Neem contact op:</p>
        <p>
          <a href="mailto:Dylan@Molenaar.eu?subject=Werfbeheer%20Software" className="help-button">
            Contact Support
          </a>
        </p>
      </div>

      </div>{/* Einde help-content */}

      {/* Versie */}
      <div className="help-footer">
        <p>Buro42 v1.0 - Werfbeheer Software</p>
      </div>
    </div>
  );
};

export default Help;
